import React from 'react';
import Typography from '@mui/material/Typography';
import { SxProps, Theme, useTheme } from '@mui/material/styles';

interface PageTitleProps {
  title: string;
  sx?: SxProps<Theme>;
  className?: string;
  appColors?: boolean;
}

const PageTitle: React.FC<PageTitleProps> = ({ title, sx, className, appColors = false }) => {
  const theme = useTheme();

  return (
    <Typography
      className={className}
      sx={{
        textTransform: 'capitalize',
        fontSize: '2rem',
        fontWeight: 700,
        lineHeight: 'normal',
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        width: 'max-content',
        background: appColors ? 'linear-gradient(90deg, #1CB0C8 0%, #FF3DA3 100%)' : theme.palette.text.primary,
        backgroundclip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        ...sx
      }}
    >
      {title}
    </Typography>
  );
};

export default PageTitle;
